module.exports = __webpack_public_path__ + "img/side-downarrow.d6e7dd27.svg";